import types from './types';

const initialState = {
  code: null,
  showErrorPopup: false,
  reduxFormData: null,
  uuidNumber: null,
  isMobile: null
};

const reducerShared = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MESSAGE:
      return {
        ...state,
        code: action.code,
        showToastMessage: action.flag,
        uuidNumber: action.uuidNumber ? action.uuidNumber : null
      };

    case types.REDUX_FORM_DATA: {
      return {
        ...state,
        reduxFormData: action.data
      }
    }

    case types.SET_IS_MOBILE_BREAKPOINT: {
      return {
        ...state,
        isMobile: action.payload
      };
    }

    default:
      return state;
  }
};

export default reducerShared;